import { Injectable } from '@angular/core';
import { SafeStorageService } from '../shared/safe-storage.service';

@Injectable({
  providedIn: 'root',
})
export class StorageService {

  constructor(private safe: SafeStorageService) {}

  getItem(key: string): string | null {
    return typeof window !== 'undefined' ? this.safe.getItem(key) : null;
  }

  setItem(key: string, value: string): void {
    if (typeof window !== 'undefined') {
      this.safe.setItem(key, value);
    }
  }

  removeItem(key: string): void {
    if (typeof window !== 'undefined') {
      this.safe.removeItem(key);
    }
  }
}
